import axios from "axios";
import { CERTIFIED_PAYROLL_SETTINGS, SET_ERROR } from "../../types";
import ToastMessage from "../../../components/toast";
export const getCertifiedSettings = (company, populateEC) => {
    return async dispatch => {
        await axios.get(`/api/certified-payroll/settings/${company}/${populateEC ? true : ""}`).then(res => {
            dispatch({
                type: CERTIFIED_PAYROLL_SETTINGS,
                payload: res.data
            });
        }).catch(e => {
            ToastMessage(e.message, "error");
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const saveCertifiedSettings = payload => {
    return async dispatch => {
        await axios.post('api/certified-payroll/settings', payload).then(res => {
            ToastMessage("Settings successfully updated!", "success");
            dispatch({
                type: CERTIFIED_PAYROLL_SETTINGS,
                payload: res.data
            });
        }).catch(e => {
            ToastMessage(e.message, "error");
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};